import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {DataService} from "../../services/data.service";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {setJobFilter} from "../../store/actions/filter.actions";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss']
})
export class ToggleButtonComponent implements OnInit {

  elementId = '';
  label = '';
  settingsKey = '';
  isChecked = false;

  @Input('label') set setLabel(value: string) {
    if (typeof value !== 'undefined') {
      this.label = value;
    }
  }

  @Input('job-filter-key') set setJobFilterKey(value: string) {
    if (typeof value !== 'undefined') {
      this.settingsKey = value;

      this.store.select(getFilterByKey(this.settingsKey)).pipe(untilDestroyed(this)).subscribe(response => {
        if (response !== null) {
          this.isChecked = response;
          this.stateChanged.emit(this.isChecked);
        }
      });

    }
  }

  @Output('stateChanged') stateChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private data: DataService,
    private store: Store<AppState>
  ) {
    this.elementId = Math.random().toString(36).substring(7);
  }

  ngOnInit(): void {

  }

  toggleButton(event: any): void {
    this.isChecked = !this.isChecked;
    this.stateChanged.emit(this.isChecked);

    if (this.settingsKey === '') {
      return
    }

    this.store.dispatch(setJobFilter({key: this.settingsKey, value: this.isChecked}));
  }

}
